<template>
    <div class="current-speaker-wrapper">
        <v-kyan-animatie class="kyan-small-screen" v-if="isSmallScreen"></v-kyan-animatie>
        <div class="white-card">
            <h2>{{ cardText }}</h2>
        </div>
        <div class="start-button">
            <v-speaker-card-button></v-speaker-card-button>
        </div>
    </div>
</template>

<style lang="scss"></style>

<script>
    import { AppState } from '@/app/data';
    import KyanAnimatie from '@/app/components/KyanAnimatie';
    import SpeakerCardButton from './SpeakerCardButton';

    export default {
        components: {
            'v-speaker-card-button': SpeakerCardButton,
            'v-kyan-animatie': KyanAnimatie
        },

        data()
        {
            return {
                isSmallScreen: false
            };
        },

        computed: {
            currentStatus()
            {
                return this.$store.getters['status/currentStatus'];
            },

            cardText()
            {
                switch( this.currentStatus )
                {
                        case AppState.READYTOSTART:
                            // STATUS: READYTOSTART
                            return 'Iedereen wakker?';
                        case AppState.READYFORNEXT:
                            // STATUS: READYFORNEXT
                            return this.$store.getters['people/findActiveSpeaker'].name;
                        case AppState.BUSY:
                            // STATUS: BUSY
                            return;
                        case AppState.ENDED:
                            // STATUS: ENDED
                            return 'Aan het werk!';
                        default:
                            // ERROR: Something went wrong, returning undefined.
                            console.log( `ERROR: Something didn't go to well, is this right? → ${this.currentStatus}` );
                            return undefined;
                }
            }
        },

        mounted()
        {
            window.addEventListener( 'resize', this.checkWindowWidth.bind( this ) );
            this.checkWindowWidth();
        },

        methods: {
            checkWindowWidth()
            {
                window.innerWidth < 1250 ? this.isSmallScreen = true : this.isSmallScreen = false;
            }
        }
    };
</script>
